export default __webpack_public_path__ + "static/media/womenTop.64a85c5b.svg";